import { jsx as _jsx } from "react/jsx-runtime";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
import { Box } from "@gemini/core";
export const CarouselAdCustomFallback = () => {
    const { t } = useI18n();
    const isProject = useIsNewBuildProject();
    return (_jsx(Box, { marginHorizontal: "spacing.56", textAlign: "center", display: "flex", children: _jsx(Box, { as: "span", typography: "typography.headline.24.bold", color: "color.content.default.inverted.default", marginBottom: "spacing.24", children: isProject
                ? t("gallery.image.ad.fallback.project.text")
                : t("gallery.image.ad.fallback.text") }) }));
};
